import ReactGA from 'react-ga4'
import { isProd } from '../../utils/isProd'
import { googleConstants } from '../../constants'

export const initializeGA = () => {
  if (isProd && googleConstants.measuringId) {
    ReactGA.initialize(googleConstants.measuringId)
  } else {
    console.log('Google Analytics initialization skipped in development')
  }
}

export const trackGAPageView = (page, title) => {
  if (isProd) {
    ReactGA.send({ hitType: 'pageview', page, title })
  }
}

export const trackGAEvent = (category, action, label = '', value = null) => {
  if (isProd) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    })
  }
}

export const setGAUser = (userId) => {
  if (isProd && userId) {
    ReactGA.set({ userId })
  }
}
